import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  monthLabel: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[6],
    lineHeight: '125%',
    textTransform: 'capitalize',
    color: Theme.palette.primary.main,
  },
  monthWeekdayLabels: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    justifyContent: 'center',
    marginBottom: Theme.spacing(1),
    fontSize: Theme.typography.pxToRem(10),
    margin: '20px 0px 10px 0px',
  },
  monthDaysLabel: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[500],
    textAlign: 'center',
    minWidth: 35,
  },
  monthDays: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    justifyContent: 'center',
    textAlign: 'center',
  },
  monthWrapper: {
    minHeight: '374px',
    [Theme.breakpoints.up('xs')]: {
      margin: '30px 20px 0px 20px',
      minHeight: '0px',
    },
    [Theme.breakpoints.up('md')]: {
      margin: '30px 50px 0px 50px',
      minHeight: '374px',
    },
    [Theme.breakpoints.up('lg')]: {
      margin: 0,
      minHeight: '374px',
    },
  },
}));

export default useStyles;
